(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory((function webpackLoadOptionalExternalModule() { try { return require("validator"); } catch(e) {} }()));
	else if(typeof define === 'function' && define.amd)
		define("Baqend", ["validator"], factory);
	else if(typeof exports === 'object')
		exports["Baqend"] = factory((function webpackLoadOptionalExternalModule() { try { return require("validator"); } catch(e) {} }()));
	else
		root["Baqend"] = factory(root["validator"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__83__) {
return 